import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { ConfigType, PluginconfigType } from "../../contexts/AppConfigContext";
import { OrderType } from "../../contexts/OrderContext";
import { useAppConfig } from "../../hooks/useAppConfig";
import { useOrder } from "../../hooks/useOrder";
import { usePluginspace } from "../../hooks/usePluginspace";
import api from "../../services/api";
import { CategoryIcon } from "../MenuIcons/CategoryIcon";
import { ChatIcon } from "../MenuIcons/ChatIcon";
import { HomeIcon } from "../MenuIcons/HomeIcon";
import { InfoIcon } from "../MenuIcons/InfoIcon";
import { OrderIcon } from "../MenuIcons/OrderIcon";
import { ModalInfo } from "../ModalInfo";
import { ModalResume } from "../ModalResume";
import "./index.css";
import { useSeller } from "../../hooks/useSeller";
import { Footer } from "../Footer/footer";
import { CallWaiterIcon } from "../MenuIcons/CallWaiter";
import { useFoodConfig } from "../../hooks/useFood";
import { HomeIconAgregator } from "../MenuIcons/HomeIconAgregator";
import { ContaIcon } from "../MenuIcons/ContaIcon";
import { CardapioIcon } from "../MenuIcons/CardapioIcon";
import HotelIcon from "../MenuIcons/HotelIcon";
import { MenuAttendanceIcon } from "../MenuAttendanceIcon";

type MenuProps = {
  activeMenu?:
    | "home"
    | "category"
    | "cart"
    | "order"
    | "info"
    | "chat"
    | "callWaiter"
    | "resume"
    | "attendance";
  colorIcons: string;
  highlightColorIcons: string;
  backgroundMenu: string;
  fontColor: string;
  activeFontColor: string;
  hide?: boolean;
  fontCart: string;
  backgroundCart: string;
  noSales: boolean;
};

type RedeSocial = {
  id: number;
  name: string;
  url: string;
  type: string;
};

export function Menu({
  activeMenu,
  colorIcons,
  highlightColorIcons,
  backgroundMenu,
  fontColor,
  activeFontColor,
  hide,
  fontCart,
  backgroundCart,
  noSales,
}: MenuProps) {
  const { pluginspace_id } = useParams();
  const navigate = useNavigate();
  const orderContext = useOrder();
  const [openInfo, setOpenInfo] = useState(false);
  const [order, setOrder] = useState<OrderType>();
  const { getToken, pluginspace } = usePluginspace();
  const { setTypeModal, setOpenModal } = useFoodConfig();
  const { getAppConfig, getPluginconfig, redeSocial } = useAppConfig();
  const [config, setConfig] = useState<ConfigType | void>();
  const [pluginconfigs, setPluginconfigs] = useState<PluginconfigType[]>([]);
  const [tableNumber, setTableNumber] = useState<string | null>(null);
  const [cardNumber, setCardNumber] = useState<string | null>(null);
  const [internalNumber, setInternalNumber] = useState<string | null>(null);
  const [openResume, setOpenResume] = useState(false);

  const [hasSearchSocialMedia, setHasSearchSocialMedia] = useState(false);

  const { getTokenSeller } = useSeller();
  const [isSeller, setIsSeller] = useState(false);
  const [isSynkar, setIsSynkar] = useState(false);

  const [isFromAgregator, setIsFromAgregator] = useState(false);

  const [isFromNewHotel, setIsFromNewHotel] = useState(false);

  console.log('[Menu] COMPONENT RENDERED - isSeller:', isSeller);

  function activeInfo() {
    setOpenInfo(true);
  }

  async function saveOrderContext() {
    const orderToStorage = Object.assign(orderContext);
    if (orderToStorage.order !== undefined) {
      await orderContext.encryptOrderStorage(orderToStorage);
    }
  }

  async function loadOrder() {
    const newOrder = await orderContext.getOrder(
      pluginspace_id ? pluginspace_id : ""
    );
    setOrder(newOrder);
  }

  async function getPluginconfigs() {
    setPluginconfigs(await getPluginconfig());
  }

  async function getConfig() {
    setConfig(await getAppConfig());
  }

  function activeResume() {
    setOpenResume(true);
  }

  function loadTableCard() {
    const _tableNumber = localStorage.getItem("table_number");
    if (_tableNumber !== null) {
      setTableNumber(window.atob(_tableNumber));
    }
    const _cardNumber = localStorage.getItem("card_number");
    if (_cardNumber !== null) {
      setCardNumber(window.atob(_cardNumber));
    }
    const _internalNumber = localStorage.getItem("internal_number");
    if (_internalNumber !== null) {
      setInternalNumber(window.atob(_internalNumber));
    }
  }

  async function goToFoodMenu() {
    if (config && config.content.pdv.showLayout === "l2") {
      navigate(`/${pluginspace_id}/products-new`);
    } else {
      navigate(`/${pluginspace_id}/products`);
    }
  }

  function setSeller() {
    const tk = getTokenSeller();
    console.log('===== [Menu] setSeller() CALLED =====');
    console.log('[Menu] getTokenSeller():', tk);
    console.log('[Menu] tk?.profile:', tk?.profile);
    console.log('[Menu] tk?.plugintype:', tk?.plugintype);
    //console.log('[Menu] localStorage seller-tk:', localStorage.getItem('seller-tk'));
    
    if (tk && (tk.profile === "seller" || tk.profile === "vendedor" || tk.plugintype === "seller")) {
      console.log('[Menu] ✅ SELLER DETECTED - Setting isSeller to TRUE');
      setIsSeller(true);
    } else {
      console.log('[Menu] ❌ NOT A SELLER or token missing');
    }
  }

  const navigateToOrder = () => {
    if (isSeller) {
      navigate(`/${pluginspace_id}/sellerOrder`);
    } else {
      navigate(`/${pluginspace_id}/search-order`);
    }
  };

  const getLandmark = () => {
    const landmark = localStorage.getItem("landmark_synkar");
    if (landmark) {
      const landmarkItem = JSON.parse(window.atob(landmark));
      return landmarkItem.interval;
    } else {
      return null;
    }
  };

  const getCounterNumber = () => {
    return localStorage.getItem("counter_number");
  };

  const getCardNumber = () => {
    return localStorage.getItem("card_number");
  };

  const getTableNumber = () => {
    return localStorage.getItem("table_number");
  };

  const getInternalNumber = () => {
    return localStorage.getItem("internal_number");
  };

  const navigateToCart = () => {
    try {
      // ✅ 1. Verificar comanda (localStorage é a fonte correta)
      const cardNumber = localStorage.getItem("card_number");

      // ✅ 2. Verificar se é template food/retail SEM mesa/comanda/balcão
      const hasTableNumber = getTableNumber();
      const hasCardNumber = getCardNumber(); // localStorage fallback
      const hasLandmark = getLandmark();
      const hasCounterNumber = getCounterNumber();
      const hasInternalNumber = getInternalNumber();

      const isFood = pluginspace?.type === "food";
      const hasAnyFoodMode =
        hasTableNumber ||
        hasCardNumber ||
        hasLandmark ||
        hasCounterNumber ||
        hasInternalNumber;
      const hasAppLogin = pluginspace?.appLogin;

      if (hasAnyFoodMode || cardNumber) {
        navigate(`/${pluginspace_id}/cart-card`);
        return;
      }

      // ✅ 3. Se for retail/ecommerce sem modo food e sem vendedor -> novo carrinho
      if (pluginspace && !isFood && !hasAnyFoodMode && !isSeller) {
        navigate(`/${pluginspace_id}/new-cart`);
        return;
      }


      // ✅ 4. Todos os outros casos -> carrinho padrão
      // (Vendedor, Food, ou sem login)
      navigate(`/${pluginspace_id}/cart`);
    } catch (error) {
      console.error("Erro ao navegar para carrinho:", error);
      // ✅ 5. Fallback em caso de erro
      try {
        navigate(`/${pluginspace_id}/cart`);
      } catch (fallbackError) {
        console.error("Erro crítico na navegação:", fallbackError);
        // Último recurso: reload com hash
        window.location.href = `/${pluginspace_id}/cart`;
      }
    }
  };

  useEffect(() => {
    console.log('[Menu] useEffect triggered - calling saveOrderContext, loadOrder, etc.');
    saveOrderContext();
    loadOrder();
    getConfig();
    getPluginconfigs();
    loadTableCard();
    setSeller();
  }, [orderContext]);

  useEffect(() => {
    const landmarkSynkar = localStorage.getItem("landmark_synkar");
    setIsSynkar(landmarkSynkar ? true : false);
  }, []);

  useEffect(() => {
    const isFromAgregator = localStorage.getItem("aggregator_link");
    setIsFromAgregator(isFromAgregator ? true : false);
  }, []);

  useEffect(() => {
    const isFromNewHotel = sessionStorage.getItem("hotelReservationContext");
    setIsFromNewHotel(isFromNewHotel ? true : false);
  }, []);

  if (pluginspace?.appLogin && !isSeller) {
    return (
      <div
        className={hide ? "all-menu-footer all-menu-hide" : "all-menu-footer"}
      >
        <Footer />
      </div>
    );
  }

  function whatAppLink() {
    let sellerGetPhone = redeSocial.find((config) => {
      return config.type === "WHATSAPP";
    });

    let phoneFound = "";

    if (sellerGetPhone) {
      phoneFound = sellerGetPhone.url.replace(/\D/g, "");
    }

    window.open(
      `https://wa.me/${phoneFound}?text=Gostaria%20de%20algumas%20informações`,
      "_blank",
      "noopener,noreferrer"
    );
  }

  async function callWaiter() {
    try {
      setTypeModal("Chamar Garçom");
      setOpenModal(true);
    } catch (error) {}
  }

  function navigateToAggregator() {
    const isFromAgregator = localStorage.getItem("aggregator_link");
    if (isFromAgregator) {
      localStorage.removeItem("aggregator_link");

      const decodedUrl = window.atob(isFromAgregator);

      if (
        !decodedUrl.startsWith("http://") &&
        !decodedUrl.startsWith("https://")
      ) {
        // Adicione o protocolo adequado, como "https://"
        window.location.href = "https://" + decodedUrl;
      } else {
        window.location.href = decodedUrl;
      }
    }
  }

  const getHotelBaseUrl = () => {
    const apiUrl = process.env.REACT_APP_API_URL ?? "";

    if (apiUrl.includes("staging")) {
      return "https://hospitality-staging.ninegrid.com.br/";
    }

    if (apiUrl.includes("localhost")) {
      return "http://localhost:7040/";
    }

    return "http://hospitality.ninegrid.com.br/";
  };

  const navigateToNewHotel = () => {
    const stored = sessionStorage.getItem("hotelReservationContext");
    if (!stored) return;

    const { subdomain } = JSON.parse(stored) as { subdomain?: string };
    if (!subdomain) return;

    const encodedSubdomain = window.btoa(subdomain);
    const url = `${getHotelBaseUrl()}${encodedSubdomain}`;

    window.location.href = url;
  };

  return (
    <>
      <div className={hide ? "all-menu all-menu-hide" : "all-menu"}>
        <div className="menu" style={{ backgroundColor: backgroundMenu }}>
          {isFromNewHotel ? (
            <div
              className="menu-item"
              onClick={() => {
                navigateToNewHotel();
              }}
            >
              <HotelIcon
                active={!openInfo && activeMenu === "home"}
                color={colorIcons}
                activeColor={highlightColorIcons}
              />

              <p
                style={
                  !openInfo && activeMenu === "home"
                    ? {
                        color: activeFontColor,
                        fontWeight: 600,
                      }
                    : { color: fontColor }
                }
              >
                Início
              </p>
            </div>
          ) : isFromAgregator ? (
            <div
              className="menu-item"
              onClick={() => {
                navigateToAggregator();
              }}
            >
              <HomeIconAgregator
                active={!openInfo && activeMenu === "home"}
                color={colorIcons}
                activeColor={highlightColorIcons}
              />

              <p
                style={
                  !openInfo && activeMenu === "home"
                    ? {
                        color: activeFontColor,
                        fontWeight: 600,
                      }
                    : { color: fontColor }
                }
              >
                Início
              </p>
            </div>
          ) : (
            <>
              {!isSynkar &&
                tableNumber === null &&
                cardNumber === null &&
                internalNumber === null &&
                config &&
                config.content &&
                config.content.pdv &&
                !config.content.pdv.skipEntry && (
                  <div
                    className="menu-item"
                    onClick={() => navigate(`/${pluginspace_id}`)}
                  >
                    <HomeIcon
                      active={!openInfo && activeMenu === "home"}
                      color={colorIcons}
                      activeColor={highlightColorIcons}
                    />
                    <p
                      style={
                        !openInfo && activeMenu === "home"
                          ? {
                              color: activeFontColor,
                              fontWeight: 600,
                            }
                          : { color: fontColor }
                      }
                    >
                      Início
                    </p>
                  </div>
                )}
            </>
          )}
          <div
            className="menu-item"
            onClick={() =>
              config?.template === "food" || config?.template === "retail"
                ? goToFoodMenu()
                : navigate(`/${pluginspace_id}/category`)
            }
          >
            {config?.template === "food" || config?.template === "retail" ? (
              <CardapioIcon
                active={!openInfo && activeMenu === "category"}
                color={colorIcons}
                activeColor={highlightColorIcons}
              />
            ) : (
              <CategoryIcon
                active={!openInfo && activeMenu === "category"}
                color={colorIcons}
                activeColor={highlightColorIcons}
              />
            )}

            <p
              style={
                !openInfo && activeMenu === "category"
                  ? {
                      color: activeFontColor,
                      fontWeight: 600,
                    }
                  : { color: fontColor }
              }
            >
              {config?.template === "food" || config?.template === "retail"
                ? "Cardápio"
                : "Catálogo"}
            </p>
          </div>
          {!noSales && (
            <div className="menu-item" onClick={() => navigateToCart()}>
              {order &&
              order.products &&
              order.products.filter((product) => !product.table).length > 0 ? (
                <div className="cart-with-items-menu">
                  {!openInfo && activeMenu === "cart" ? (
                    <svg
                      width="28"
                      height="28"
                      viewBox="0 0 52 52"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M0.999512 3.33954C0.999512 2.0398 1.93963 1 3.0998 1H7.08041C9.0107 1 10.7109 2.24975 11.5111 4.12938H47.4965C49.7968 4.12938 51.4771 6.56889 50.877 9.04839L47.2865 23.9154C46.5463 26.9848 44.0459 29.1244 41.2055 29.1244H20.4324L20.9025 31.9038C21.0925 33.0036 21.9627 33.8034 22.9728 33.8034H43.7359C44.8961 33.8034 45.8362 34.8432 45.8362 36.143C45.8362 37.4427 44.8961 38.4825 43.7359 38.4825H22.9728C19.9424 38.4825 17.342 36.083 16.7819 32.7737L7.78053 6.31894C7.72052 5.94901 7.43047 5.68906 7.09042 5.68906H3.10981C1.94964 5.68906 1.00949 4.64928 1.00949 3.34954L0.999512 3.33954ZM16.6918 46.3009C16.6918 43.7115 18.8122 41.6119 21.4326 41.6119C24.053 41.6119 26.1733 43.7115 26.1733 46.3009C26.1733 48.8904 24.053 50.99 21.4326 50.99C18.8122 50.99 16.6918 48.8904 16.6918 46.3009ZM44.8061 41.6219C47.4265 41.6219 49.5468 43.7215 49.5468 46.3109C49.5468 48.9004 47.4265 51 44.8061 51C42.1857 51 40.0654 48.9004 40.0654 46.3109C40.0654 43.7215 42.1857 41.6219 44.8061 41.6219Z"
                        fill={highlightColorIcons}
                        strokeMiterlimit="10"
                      />
                    </svg>
                  ) : (
                    <svg
                      width="28"
                      height="28"
                      viewBox="0 0 52 52"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M0.999512 3.33954C0.999512 2.0398 1.93963 1 3.0998 1H7.08041C9.0107 1 10.7109 2.24975 11.5111 4.12938H47.4965C49.7968 4.12938 51.4771 6.56889 50.877 9.04839L47.2865 23.9154C46.5463 26.9848 44.0459 29.1244 41.2055 29.1244H20.4324L20.9025 31.9038C21.0925 33.0036 21.9627 33.8034 22.9728 33.8034H43.7359C44.8961 33.8034 45.8362 34.8432 45.8362 36.143C45.8362 37.4427 44.8961 38.4825 43.7359 38.4825H22.9728C19.9424 38.4825 17.342 36.083 16.7819 32.7737L7.78053 6.31894C7.72052 5.94901 7.43047 5.68906 7.09042 5.68906H3.10981C1.94964 5.68906 1.00949 4.64928 1.00949 3.34954L0.999512 3.33954ZM16.6918 46.3009C16.6918 43.7115 18.8122 41.6119 21.4326 41.6119C24.053 41.6119 26.1733 43.7115 26.1733 46.3009C26.1733 48.8904 24.053 50.99 21.4326 50.99C18.8122 50.99 16.6918 48.8904 16.6918 46.3009ZM44.8061 41.6219C47.4265 41.6219 49.5468 43.7215 49.5468 46.3109C49.5468 48.9004 47.4265 51 44.8061 51C42.1857 51 40.0654 48.9004 40.0654 46.3109C40.0654 43.7215 42.1857 41.6219 44.8061 41.6219Z"
                        stroke={colorIcons}
                        strokeMiterlimit="10"
                      />
                    </svg>
                  )}
                  <div
                    className="circle-number"
                    style={{
                      backgroundColor: backgroundCart,
                    }}
                  >
                    <p style={{ color: fontCart }}>
                      {
                        order.products.filter((product) => !product.table)
                          .length
                      }
                    </p>
                  </div>
                </div>
              ) : !openInfo && activeMenu === "cart" ? (
                <svg
                  width="28"
                  height="28"
                  viewBox="0 0 52 52"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M0.999512 3.33954C0.999512 2.0398 1.93963 1 3.0998 1H7.08041C9.0107 1 10.7109 2.24975 11.5111 4.12938H47.4965C49.7968 4.12938 51.4771 6.56889 50.877 9.04839L47.2865 23.9154C46.5463 26.9848 44.0459 29.1244 41.2055 29.1244H20.4324L20.9025 31.9038C21.0925 33.0036 21.9627 33.8034 22.9728 33.8034H43.7359C44.8961 33.8034 45.8362 34.8432 45.8362 36.143C45.8362 37.4427 44.8961 38.4825 43.7359 38.4825H22.9728C19.9424 38.4825 17.342 36.083 16.7819 32.7737L7.78053 6.31894C7.72052 5.94901 7.43047 5.68906 7.09042 5.68906H3.10981C1.94964 5.68906 1.00949 4.64928 1.00949 3.34954L0.999512 3.33954ZM16.6918 46.3009C16.6918 43.7115 18.8122 41.6119 21.4326 41.6119C24.053 41.6119 26.1733 43.7115 26.1733 46.3009C26.1733 48.8904 24.053 50.99 21.4326 50.99C18.8122 50.99 16.6918 48.8904 16.6918 46.3009ZM44.8061 41.6219C47.4265 41.6219 49.5468 43.7215 49.5468 46.3109C49.5468 48.9004 47.4265 51 44.8061 51C42.1857 51 40.0654 48.9004 40.0654 46.3109C40.0654 43.7215 42.1857 41.6219 44.8061 41.6219Z"
                    fill={highlightColorIcons}
                    strokeMiterlimit="10"
                  />
                </svg>
              ) : (
                <svg
                  width="28"
                  height="28"
                  viewBox="0 0 52 52"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M0.999512 3.33954C0.999512 2.0398 1.93963 1 3.0998 1H7.08041C9.0107 1 10.7109 2.24975 11.5111 4.12938H47.4965C49.7968 4.12938 51.4771 6.56889 50.877 9.04839L47.2865 23.9154C46.5463 26.9848 44.0459 29.1244 41.2055 29.1244H20.4324L20.9025 31.9038C21.0925 33.0036 21.9627 33.8034 22.9728 33.8034H43.7359C44.8961 33.8034 45.8362 34.8432 45.8362 36.143C45.8362 37.4427 44.8961 38.4825 43.7359 38.4825H22.9728C19.9424 38.4825 17.342 36.083 16.7819 32.7737L7.78053 6.31894C7.72052 5.94901 7.43047 5.68906 7.09042 5.68906H3.10981C1.94964 5.68906 1.00949 4.64928 1.00949 3.34954L0.999512 3.33954ZM16.6918 46.3009C16.6918 43.7115 18.8122 41.6119 21.4326 41.6119C24.053 41.6119 26.1733 43.7115 26.1733 46.3009C26.1733 48.8904 24.053 50.99 21.4326 50.99C18.8122 50.99 16.6918 48.8904 16.6918 46.3009ZM44.8061 41.6219C47.4265 41.6219 49.5468 43.7215 49.5468 46.3109C49.5468 48.9004 47.4265 51 44.8061 51C42.1857 51 40.0654 48.9004 40.0654 46.3109C40.0654 43.7215 42.1857 41.6219 44.8061 41.6219Z"
                    stroke={colorIcons}
                    strokeMiterlimit="10"
                  />
                </svg>
              )}
              <p
                style={
                  !openInfo && activeMenu === "cart"
                    ? {
                        color: activeFontColor,
                        fontWeight: 600,
                      }
                    : { color: fontColor }
                }
              >
                Carrinho
              </p>
            </div>
          )}
          {tableNumber == null && cardNumber === null && (
            <div className="menu-item" onClick={() => navigateToOrder()}>
              <OrderIcon
                active={!openInfo && activeMenu === "order"}
                color={colorIcons}
                activeColor={highlightColorIcons}
              />
              <p
                style={
                  !openInfo && activeMenu === "order"
                    ? {
                        color: activeFontColor,
                        fontWeight: 600,
                      }
                    : { color: fontColor }
                }
              >
                {tableNumber !== null || cardNumber !== null
                  ? "Conta"
                  : "Pedidos"}
              </p>
            </div>
          )}
          <div
            className="menu-item"
            onClick={() => {
              navigate(`/${pluginspace_id}/store-info`);
            }}
          >
            <InfoIcon
              active={activeMenu === "info" || openInfo}
              color={colorIcons}
              activeColor={highlightColorIcons}
            />
            <p
              style={
                activeMenu === "info" || openInfo
                  ? {
                      color: activeFontColor,
                      fontWeight: 600,
                    }
                  : { color: fontColor }
              }
            >
              Info
            </p>
          </div>
          {isSeller && (
            <div className="menu-item">
              <MenuAttendanceIcon
                active={activeMenu === "attendance"}
                colorIcons={colorIcons}
                highlightColorIcons={highlightColorIcons}
                fontColor={fontColor}
                activeFontColor={activeFontColor}
              />
            </div>
          )}
          {(tableNumber !== null || cardNumber !== null) &&
            !config?.content.pdv.ableWinter && (
              <div className="menu-item" onClick={callWaiter}>
                <CallWaiterIcon
                  active={!openInfo && activeMenu === "callWaiter"}
                  color={colorIcons}
                  activeColor={highlightColorIcons}
                />
                <p
                  style={
                    !openInfo && activeMenu === "resume"
                      ? {
                          color: activeFontColor,
                          fontWeight: 600,
                        }
                      : { color: fontColor }
                  }
                >
                  Garçom
                </p>
              </div>
            )}
          {(tableNumber !== null || cardNumber !== null) && (
            <div className="menu-item" onClick={activeResume}>
              <ContaIcon
                active={!openInfo && activeMenu === "resume"}
                color={colorIcons}
                activeColor={highlightColorIcons}
              />
              <p
                style={
                  !openInfo && activeMenu === "resume"
                    ? {
                        color: activeFontColor,
                        fontWeight: 600,
                      }
                    : { color: fontColor }
                }
              >
                Conta
              </p>
            </div>
          )}

          {!isSeller &&
            redeSocial.find((config) => {
              return config.type === "WHATSAPP";
            }) && (
              <div className="menu-item" onClick={() => whatAppLink()}>
                <svg
                  width="23"
                  height="23"
                  viewBox="0 0 23 23"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M1 22.3117C1.52 20.8753 1.95475 19.5796 2.46197 18.3137C2.72197 17.6615 2.6751 17.133 2.33837 16.5065C-1.43804 9.43102 3.68951 0.957537 11.7027 1.00016C16.8899 1.03 21.3994 5.01528 22.0856 10.1812C22.9893 16.9711 17.4269 22.7635 10.5817 22.0858C9.51609 21.9792 8.46757 21.5445 7.44461 21.1609C6.8351 20.9308 6.28953 20.8284 5.6587 21.0202C4.34591 21.4209 3.02461 21.7747 1.70329 22.1412C1.5328 22.1881 1.35803 22.2222 1 22.3075V22.3117ZM14.4135 17.3632C15.6581 17.3589 16.6299 16.8091 17.086 15.9822C17.606 15.0317 17.4099 14.3412 16.4722 13.8468C16.2719 13.7402 16.063 13.6422 15.8627 13.5356C14.486 12.8153 14.4689 12.8025 13.5525 14.0258C13.1987 14.4947 12.8663 14.5245 12.3846 14.2815C11.0633 13.6124 10.0446 12.632 9.22626 11.4045C8.86822 10.8674 8.84265 10.4242 9.28167 9.92974C9.64397 9.52482 9.87413 9.05169 9.65249 8.48054C9.38823 7.79857 9.1197 7.12084 8.85544 6.43887C8.67216 5.9615 8.33971 5.79954 7.82823 5.86347C6.63905 6.01265 5.49248 7.82415 5.82067 9.07301C6.64756 12.2271 8.5784 14.5501 11.2892 16.2593C12.3037 16.8986 13.4246 17.295 14.422 17.3632H14.4135Z"
                    stroke={colorIcons}
                    stroke-miterlimit="10"
                    stroke-linejoin="round"
                  />
                </svg>

                <p
                  style={
                    !openInfo && activeMenu === "chat"
                      ? {
                          color: activeFontColor,
                          fontWeight: 600,
                        }
                      : { color: fontColor }
                  }
                >
                  Whatsapp
                </p>
              </div>
            )}
        </div>
      </div>
      {openInfo && <ModalInfo isOpen={openInfo} setIsOpen={setOpenInfo} />}

      {openResume && (
        <ModalResume
          isOpen={openResume}
          setIsOpen={setOpenResume}
          tableNumber={tableNumber ? parseInt(tableNumber) : 0}
          cardNumber={cardNumber ? parseInt(cardNumber) : 0}
          paymentTable={
            config?.content.pdv.paymentTable
              ? config?.content.pdv.paymentTable
              : false
          }
          paymentCard={
            config?.content.pdv.paymentCard
              ? config?.content.pdv.paymentCard
              : false
          }
          webappbutton={
            config?.webappcolor.webappbutton
              ? config.webappcolor.webappbutton
              : "#EAEAEA"
          }
          fontbutton={
            config?.webappcolor.fontbutton
              ? config.webappcolor.fontbutton
              : "#636363"
          }
        />
      )}
    </>
  );
}
